import React, { useState } from 'react';
import styled from 'styled-components';
import { useFormik } from 'formik';
import { useAuth } from '../../context/AuthContext';
import server from '../../../../global/server';
import useHandleErrors from '../../../../hooks/useHandleErrors';
import Typography from '@mui/material/Typography';
import { useApp } from '../../../../context/AppContext';
import LoadingButton from '@mui/lab/LoadingButton';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { useNavigate } from 'react-router-dom';
import bg from '../../../../assets/imgs/bg.jpeg'
export default props => {
    const { verifySession, setUser } = useAuth();
    const { isOffline } = useApp();
    const [hasError, setError] = useState();
    useHandleErrors(hasError);

    const navigation = useNavigate()

    const { values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting } = useFormik({
        initialValues: { email: '', password: '' },
        onSubmit: async (values, { setSubmitting }) => {
            try {
                setSubmitting(true);
                const { data } = await server.post('auth/login', values);
                localStorage.setItem('token', data.token);
                localStorage.setItem('user', JSON.stringify(data.user));
                setUser(data.user);
                verifySession();
                setSubmitting(false);
                navigation('/profile/view')
                
            } catch (error) {
                setSubmitting(false);
                setError(error);
            }
        },
    });

    return (
        <PanelAuth bg={bg}>
            <div>
                {/* <Logo>
                    <img width={250} src={logo}sx={{ marginBottom: 20 }} />
                </Logo> */}
                <BoxAuth>
                    <form onSubmit={handleSubmit}>
                        <Grid container direction="column" gap={2}>
                            <Grid>
                                <Title>
                                    <Typography variant="h6">Acesse seu perfil</Typography>
                                </Title>
                            </Grid>
                            <Grid>
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    required
                                    label="E-mail"
                                    type="text"
                                    name="email"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.email}
                                    disabled={isOffline}
                                />
                            </Grid>
                            <Grid>
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    label="Senha"
                                    type="password"
                                    name="password"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.password}
                                    disabled={isOffline}
                                />
                            </Grid>
                            <Grid>
                                <LoadingButton
                                    type="submit"
                                    fullWidth
                                    loading={isSubmitting}
                                    variant="contained"
                                    disabled={!(values.email && values.password) || isSubmitting || isOffline}
                                >
                                    Entrar
                                </LoadingButton>
                            </Grid>
                            <Grid>
                                <LoadingButton size='small'  onClick={()=>navigation('/')} fullWidth variant="text" disabled={isSubmitting}>
                                    Voltar
                                </LoadingButton>
                                <LoadingButton size='small' onClick={()=>navigation('/recovery')} fullWidth variant="text" disabled={isSubmitting}>
                                    Recuperar senha
                                </LoadingButton>
                            </Grid>
                             
                        </Grid>
                    </form>
                </BoxAuth>
            </div>
        </PanelAuth>
    );
};

const PanelAuth = styled.div`
    width: 100%;
    height: 100%;
    display: flexbox;
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #eee;
    background-image: url(${props=>props.bg});
    background-size:cover;
    background-repeat: none;

`;

const BoxAuth = styled(Grid)`
    border: 1px solid #ccc;
    border-radius: 1rem;
    padding: 2rem;
    width: 350px;
    background: white;
`;

const Title = styled.div`
    text-align: center;
    margin-bottom: 20px;
`;

const BoxAuthContainer = styled.div`
    padding: 1px;
`;
